import $ from 'jquery';

$(window).on('load', () => {
    $('.ibe-wrapper ul, .ibe-wrapper ol').addClass('no-list-bullet');
});
